import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import DetectRTC from 'detectrtc'
import 'moment/locale/fr'
import {
    END_TRANSMISSION,
    TRANSMISSION_TOTAL_PENDING,
    TRANSMISSION_STARTED,
    UPDATE_MAX_DISPLAYED_PENDING_TLE,
} from './types'
import { pageview } from '../../utils/utils'
import {
    displayFeedbackDialogContent,
    resetFeedbackDialog,
    updateFeedbackDialogContent,
    updateFeedbackDialogError,
    updateFeedbackDialogTitle,
} from './FeedbackDialogAction'
import config from '../../../../package.json'
import { LeavingOptionSubType, LeavingOptionType } from '../../components/features/medicalAct/_props'

const maxDisplayedPendingTe = parseInt(window._env_.REACT_APP_MAX_DISPLAYED_PENDING_TRANSMISSION)

export const updateMaxDisplayedPendingTle = (number: any) => (dispatch: any) => {
    dispatch({
        type: UPDATE_MAX_DISPLAYED_PENDING_TLE,
        payload: {
            maxDisplayedPendingTle: number,
        },
    })
}

export const endTransmission =
    (
        uid: any,
        transId: any,
        patientId: any,
        priceInfos: any,
        leavingOption: LeavingOptionType,
        leavingOptionSubtype?: LeavingOptionSubType,
    ) =>
    async (dispatch: any, getState: any) => {
        try {
            const isCanceled = leavingOption === 'CANCELED'

            if (isCanceled) {
                dispatch(updateFeedbackDialogTitle('Refus de la téléexpertise en cours'))
            } else {
                dispatch(updateFeedbackDialogTitle('Finalisation de la téléexpertise en cours'))
            }

            dispatch(
                updateFeedbackDialogContent({
                    progress: 0,
                }),
            )
            dispatch(displayFeedbackDialogContent(true))

            const transmission = await ToktokdocLib.Transmission.instance(transId)

            if (isCanceled || (leavingOption === 'FINISHED' && leavingOptionSubtype === 'WITHOUT_COTATION')) {
                await transmission.removeInvoice()
            }

            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 99,
                }),
            )

            const deviceInfo = {
                os: {
                    name: DetectRTC.osName,
                    version: DetectRTC.version,
                },
                browser: DetectRTC.browser,
                appVersion: config.version,
            }
            await transmission.setRequiredExpertInfos(deviceInfo)
            await transmission.finish(isCanceled)

            dispatch(
                updateFeedbackDialogContent({
                    subtitle: 'Finalisation',
                    progress: 100,
                }),
            )
            pageview('Téléexpertise', 'Fin de téléexpertise')

            const state = getState()
            const transmissionStore = state.transmission
            const transmissionIdArray = Object.keys(transmissionStore.tlist)
            const User = ToktokdocLib.User.instance(uid)
            if (transmissionIdArray.length === maxDisplayedPendingTe) {
                // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
                const lastLoadedTransmission = transmissionStore.tlist[transmissionIdArray.pop()]
                const nextTransmission = await User.getNextPendingTransmission(lastLoadedTransmission.dateTransmitted)
                if (nextTransmission) {
                    // fetchTransmissionInfo(nextTransmission.id, dispatch)
                }
            }

            dispatch({
                type: END_TRANSMISSION,
                payload: {
                    transId,
                },
            })
            dispatch({
                type: TRANSMISSION_STARTED,
                payload: false,
            })

            const totalPending = await User.getPendingTransmissionCount()
            dispatch({
                type: TRANSMISSION_TOTAL_PENDING,
                payload: totalPending,
            })
            dispatch(resetFeedbackDialog())
        } catch (error) {
            dispatch(updateFeedbackDialogError(true))
            console.log(error)
        }
    }

export const cancelSelection = () => (dispatch: any) => {
    dispatch({
        type: TRANSMISSION_STARTED,
        payload: false,
    })
}
